module.exports = __webpack_public_path__ + "img/dungeon_blue_exterior.0d32fc00.png";